import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { AssistantAuthView } from "../components/assistant/AssistantAuthView";
import { AssistantWorkspace } from "../components/assistant/AssistantWorkspace";
import { startGoogleLogin, useAuth } from "../lib/auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AssistantPage() {
  const { user: globalUser, loading: globalLoading, setUser: setGlobalUser } = useAuth();
  const [assistantUser, setAssistantUser] = useState(null);
  const [checking, setChecking] = useState(true);

  const verify = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/assistant/me`);
      setAssistantUser(response.data);
    } catch { setAssistantUser(null); }
    finally { setChecking(false); }
  }, []);

  useEffect(() => {
    if (globalLoading) return;
    if (globalUser) { setAssistantUser(globalUser); setChecking(false); return; }
    verify();
  }, [globalLoading, globalUser, verify]);

  const ownerLogin = async (credentials) => {
    try {
      const response = await axios.post(`${API}/auth/assistant/login`, credentials);
      setAssistantUser(response.data); toast.success("Private workspace unlocked");
    } catch (error) { toast.error(typeof error.response?.data?.detail === "string" ? error.response.data.detail : "Sign in failed"); }
  };

  const logout = async () => {
    try { await axios.post(`${API}/auth/assistant/logout`); } catch { /* clear local state regardless */ }
    sessionStorage.removeItem("marez_private_assistant_session");
    setAssistantUser(null); setGlobalUser(null); toast.success("Signed out securely");
  };

  if (globalLoading || checking) return <div data-testid="assistant-auth-loading" className="min-h-screen bg-[#050505] text-zinc-500 flex items-center justify-center"><Loader2 size={20} className="animate-spin mr-2" /> Checking private access…</div>;
  if (!assistantUser) return <AssistantAuthView onGoogleLogin={() => startGoogleLogin("/assistant")} onOwnerLogin={ownerLogin} />;
  return <AssistantWorkspace user={assistantUser} onLogout={logout} onUnauthorized={() => { setAssistantUser(null); setGlobalUser(null); }} />;
}
